export function CashOutTotalsFormatter(data) {
  const totales = {
    TDD: 0,
    TDC: 0,
    EFECTIVO: 0,
    TRANS: 0,
  };

  const mapFormaPago = {
    'TDD': 'TDD',
    'TDC': 'TDC',
    'DEBITO': 'TDD',
    'CRÉDITO': 'TDC',
    'CREDITO': 'TDC',
    'EFECTIVO': 'EFECTIVO',
    'TRANSFER': 'TRANS',
    'TRANSFERENCIA': 'TRANS',
    'TRANS': 'TRANS',
  };

  data.forEach(item => {
    const rawTipo = (item.CODE || item.FORMA_PAGO || '').toUpperCase();
    const tipo = mapFormaPago[rawTipo] || '';
    const monto = parseFloat(item.ACUMULADO || 0) || 0;

    if (tipo && totales.hasOwnProperty(tipo)) {
      totales[tipo] += monto;
    }
  });

  return totales;
}
